
import { takeLatest, put, call } from 'redux-saga/effects';
import * as ViewAction from './action';
import fileSaver from 'file-saver';
import { CORE_API, REPORT } from '../../../config';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../constants';
import request from '../../../components/Utils/httpHelper';

export function* caseDetails(action) {
    if (action.data && action.data !== null) {
        let requestUrl = `${CORE_API}/case/view/${action.data}`;
        try {
            const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
            yield put(ViewAction.caseDetailsSuccess(listResult));
        } catch (err) {
            yield put(ViewAction.caseDetailsFailure(err))
        }
    }
}
export function* fetchCaseDetails() {
    yield takeLatest(ViewAction.GET_CASE_DETAILS, caseDetails);
}
export function* caseSections(action) {
    let requestUrl = `${REPORT}/computedreport/metadata/${action.data}`;//	/computedreport/metadata/{computedreportid}
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.sectionSuccess(listResult));
    } catch (err) {
        yield put(ViewAction.sectionFailure(err))
    }
}
export function* fetchSections() {
    yield takeLatest(ViewAction.GET_ALL_SECTIONS, caseSections);
}
export function* sectionFileDownload(action) {
    let requestUrl = `${REPORT}/section/url/${action.data}`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.sectionDownloadFileSuccess(listResult));
    } catch (err) {
        yield put(ViewAction.sectionDownloadFileError(err))
    }
}
export function* sectionDetailFileDownload() {
    yield takeLatest(ViewAction.DOWNLOAD_SECTION_DETAILS, sectionFileDownload);
}

export function* surveyDataFileDownload(action) {
    let requestUrl = `${REPORT}/survey/download/${action.data}`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(ViewAction.sectionDownloadFileSuccess(listResult.data));
    } catch (err) {
        yield put(ViewAction.sectionDownloadFileError(err))
    }
}
export function* surveyDataDetailFileDownload() {
    yield takeLatest(ViewAction.DOWNLOAD_DATA_SURVEY_DETAILS, surveyDataFileDownload);
}

export function* surveyFinancialFileDownload(action) {
    let requestUrl = `${REPORT}/section/url/financial/${action.data}`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(ViewAction.sectionDownloadFileSuccess(listResult.data));
    } catch (err) {
        yield put(ViewAction.sectionDownloadFileError(err))
    }
}
export function* surveyFinancialDetailFileDownload() {
    yield takeLatest(ViewAction.DOWNLOAD_FINANCIAL_SURVEY_DETAILS, surveyFinancialFileDownload);
}

export function* surveyFileDownload(action) {
    let requestUrl = `${REPORT}/survey/url/${action.data}`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.sectionDownloadFileSuccess(listResult.data));
    } catch (err) {
        yield put(ViewAction.sectionDownloadFileError(err))
    }
}
export function* surveyDetailFileDownload() {
    yield takeLatest(ViewAction.DOWNLOAD_SURVEY_DETAILS, surveyFileDownload);
}

export function* predefinedFileDownload(action) {
    let requestUrl = `${REPORT}/computedreport/predefinedsection/excel/url/${action.data}`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.predefinedSectionDownloadSuccess(listResult));
    } catch (err) {
        yield put(ViewAction.predefinedSectionDownloadFailure(err))
    }
}
export function* predefinedSectionDownload() {
    yield takeLatest(ViewAction.DOWNLOAD_PREDEFINED_SECTION, predefinedFileDownload);
}

export function* sectionFileUpload(action) {
    const formData = new FormData();
    formData.append('reportRequestCaseId', action.data.reportRequestCaseId);
    formData.append('taskId', action.data.taskId)
    formData.append('counterpartyId', action.data.counterPartyId)
    formData.append('sectionTemplateId', action.data.sectionTemplateId)
    formData.append('file', action.data.file)
    let requestUrl = `${REPORT}/survey/submit`;
    try {
        const listResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(ViewAction.sectionUploadSuccess(listResult));
        yield put({ type: ViewAction.GET_ALL_SECTIONS, data: action.id })
    } catch (err) {
        yield put(ViewAction.sectionUploadFailure(err))
    }
}
export function* sectionDetailFileUpload() {
    yield takeLatest(ViewAction.UPLOAD_SECTION_DETAILS, sectionFileUpload);
}

export function* predefinedSectionFileUpload(action) {
    const formData = new FormData();
    formData.append('counterpartyid', action.data.counterpartyid);
    formData.append('computedreportid', action.data.computedreportid)
    formData.append('predefinedsectiontemplateid', action.data.predefinedsectiontemplateid)
    formData.append('file', action.data.file)
    formData.append('sequenceid', action.data.sequenceid)
    let requestUrl = `${REPORT}/computedreport/predefinedsection/edit`;
    try {
        const listResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(ViewAction.predefinedSectionUploadSuccess(listResult));
        yield put({ type: ViewAction.GET_ALL_SECTIONS, data: action.id })
    } catch (err) {
        yield put(ViewAction.predefinedSectionUploadFailure(err))
    }
}
export function* predefinedSectionUpload() {
    yield takeLatest(ViewAction.UPLOAD_PREDEFINED_SECTION, predefinedSectionFileUpload);
}

export function* sectionPdf(action) {
    let requestUrl = `${REPORT}/computedsection/pdf/url/${action.data}`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.showSectionPdfSuccess(listResult));
    } catch (err) {
        yield put(ViewAction.showSectionPdfFailure(err))
    }
}
export function* showSectionPdf() {
    yield takeLatest(ViewAction.SHOW_SECTION_PDF, sectionPdf);
}

export function* predefinedSectionsList(action) {
    let requestUrl = `${REPORT}/section/list/PREDEFINED`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.predefinedSectionsSuccess(result));
    } catch (err) {
        yield put(ViewAction.predefinedSectionsFailure(err))
    }
}
export function* getPredefinedSection() {
    yield takeLatest(ViewAction.GET_PREDEFINED_SECTIONS, predefinedSectionsList);
}

export function* addPredefinedSectionsList(action) {
    let reqobj = {
        computedReportId: action.id,
        sectionTemplateIds: action.list
    }
    let requestUrl = `${REPORT}/computedreport/predefinedsection/add`;
    try {
        const result = yield call(request, requestUrl, { data: reqobj, method: 'POST', headers: HTTP_HEADERS });
        yield put(ViewAction.addPredefinedSectionsSuccess(result));
        yield put({ type: ViewAction.GET_ALL_SECTIONS, data: action.id })

    } catch (err) {
        yield put(ViewAction.addPredefinedSectionsFailure(err))
    }
}
export function* addPredefinedSection() {
    yield takeLatest(ViewAction.ADD_PREDEFINED_SECTIONS, addPredefinedSectionsList);
}

export function* deletePredefinedSectionData(action) {

    let requestUrl = `${REPORT}/computedreport/${action.computedreportid}/predefinedsection/${action.computedsectionid}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'DELETE', headers: HTTP_HEADERS });

        //yield delay(1000)
        yield put(ViewAction.deletePredefinedSectionsSuccess(result)); // result.data when api ready
        yield put({ type: ViewAction.GET_ALL_SECTIONS, data: action.computedreportid })
    } catch (err) {
        yield put(ViewAction.deletePredefinedSectionsFailure(err))
    }
}
export function* deletePredefinedSection() {

    yield takeLatest(ViewAction.DELETE_PREDEFINED_SECTIONS, deletePredefinedSectionData);
}

export function* deleteMultipleSectionData(action) {
    let requestUrl = `${REPORT}/computedreport/${action.computedreportid}/computedsection/predefinedsection`;
    try {
        const result = yield call(request, requestUrl, { data: action.multipleSectionDeleteList, method: 'DELETE', headers: HTTP_HEADERS });


        yield put(ViewAction.deleteMultipleSectionsSuccess(result));
        yield put({ type: ViewAction.GET_ALL_SECTIONS, data: action.computedreportid })
    } catch (err) {
        yield put(ViewAction.deleteMultipleSectionsFailure(err))
    }
}
export function* deleteMultipleSection() {

    yield takeLatest(ViewAction.DELETE_MULTIPLE_SECTIONS, deleteMultipleSectionData);
}

export function* publishFinalReportToCorporate(action) {
    let requestUrl = `${CORE_API}/case/publish/${action.id}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.publishFinalReportSuccess(result));
    } catch (err) {
        yield put(ViewAction.publishFinalReportFailure(err))
    }
}
export function* publishFinalReport() {
    yield takeLatest(ViewAction.PUBLISH_FINAL_REPORT, publishFinalReportToCorporate);
}

export function* reorderSections(action) {
    let requestUrl = `${REPORT}/computedreport/section/reorder/${action.id}`;
    try {
        const result = yield call(request, requestUrl, { data: action.newState, method: 'PUT', headers: HTTP_HEADERS });
        yield put(ViewAction.reorderSectionsSuccess(result));

    } catch (err) {
        yield put(ViewAction.reorderSectionsFailure(err))
    }
}
export function* reorder() {
    yield takeLatest(ViewAction.REORDER_SECTIONS, reorderSections);
}


export function* previewReport(action) {
    let requestUrl = `${REPORT}/computedreport/preview/${action.data.id}?caseType=${action.data.caseType}&requestType=`;
    if (!(action.data.requestType == undefined || action.data.requestType == "undefined" || action.data.requestType == null || action.data.requestType == "null")) {
        requestUrl = requestUrl + action.data.requestType;
    }
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.previewReportSuccess(result.data));
    } catch (err) {
        yield put(ViewAction.previewReportFailure(err))
    }
}
export function* previewCaseReport() {
    yield takeLatest(ViewAction.PREVIEW_REPORT, previewReport);
}

export function* previewCompletedCasePdf(action) {
    let requestUrl = `${REPORT}/computedreport/pdf/url/${action.id}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.viewPublishedReportSuccess(result));
    } catch (err) {
        yield put(ViewAction.viewPublishedReportFailure(err))
    }
}
export function* previewCompletedCase() {
    yield takeLatest(ViewAction.VIEW_PUBLISHED_REPORT, previewCompletedCasePdf);
}
export function* previewDownloadedCasePdf(action) {
    let requestUrl = `${REPORT}/computedreport/pdf/download/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        var blob = new Blob([result.data],
            { type: 'application/octet-stream' });
        fileSaver.saveAs(blob, action.name + '.pdf');
        yield put(ViewAction.viewDownloadedReportSuccess(result));
    } catch (err) {
        yield put(ViewAction.viewDownloadedReportFailure(err))
    }
}
export function* previewDownloadedCase() {
    yield takeLatest(ViewAction.VIEW_DOWNLOADED_REPORT, previewDownloadedCasePdf);
}

export function* onCloseCase(action) {
    let requestUrl = `${CORE_API}/case/complete/${action.id}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'PUT', headers: HTTP_HEADERS });
        yield put(ViewAction.closeCaseSuccess(result));
        yield put({ type: ViewAction.GET_CASE_DETAILS, data: action.id })
    } catch (err) {
        yield put(ViewAction.closeCaseFailure(err))
    }
}
export function* closeCase() {
    yield takeLatest(ViewAction.CLOSE_CASE, onCloseCase);
}

export function* onReopenCase(action) {
    let requestUrl = `${CORE_API}/case/reopen/${action.id}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.reopenCaseSuccess(result));
        yield put({ type: ViewAction.GET_CASE_DETAILS, data: action.caseId })
    } catch (err) {
        yield put(ViewAction.reopenCaseFailure(err))
    }
}
export function* reopenCase() {
    yield takeLatest(ViewAction.REOPEN_CASE, onReopenCase);
}


export function* fetchCaseScorecardDetails(action) {
    let requestUrl = `${REPORT}/computedscorecard/edit/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.fetchCaseScorecardDetailsSuccess(result.data));
    } catch (err) {
        yield put(ViewAction.fetchCaseScorecardDetailsFailure(err))
    }
}
export function* caseScorecardDetails() {
    yield takeLatest(ViewAction.FETCH_CASE_SCORECARD_DETAILS, fetchCaseScorecardDetails);
}

export function* recalculateScore(action) {
    let requestUrl = `${REPORT}/computedscorecard/recalculate`;
    try {
        const result = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(ViewAction.recalculateScoreSuccess(result.data));
    } catch (err) {
        yield put(ViewAction.recalculateScoreFailure(err))
    }
}
export function* reCalculateScorecard() {
    yield takeLatest(ViewAction.RECALCULATE_SCORE, recalculateScore);
}

export function* uploadImages(action) {
    const formData = new FormData();
    formData.append('reportRequestCaseId', action.data.reportRequestCaseId);
    formData.append('taskId', action.data.taskId)
    formData.append('counterpartyId', action.data.counterPartyId)
    formData.append('sectionTemplateId', action.data.sectionTemplateId)
    for (let i = 0; i < action.data.file.length; i++) {
        formData.append("capturedImages", action.data.file[i]);
    }
    let requestUrl = `${CORE_API}/survey/submit/photograph/template`;
    try {
        const listResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(ViewAction.uploadImagesResponse(listResult));
        yield put({ type: ViewAction.GET_ALL_SECTIONS, data: action.id })
    } catch (err) {
        yield put(ViewAction.uploadImagesResponseError(err))
    }
}
export function* uploadMultipleImages() {
    yield takeLatest(ViewAction.UPLOAD_IMAGES, uploadImages);
}

export function* saveCaseScorecardEdit(action) {
    let requestUrl = `${REPORT}/computedscorecard/edit`;
    try {
        const result = yield call(request, requestUrl, { data: action.data, method: 'PUT', headers: HTTP_HEADERS });
        yield put(ViewAction.saveCaseScorecardSuccess(result.data));
    } catch (err) {
        yield put(ViewAction.saveCaseScorecardFailure(err.response.data.message))
    }
}
export function* editCaseScorecard() {
    yield takeLatest(ViewAction.SAVE_CASE_SCORECARD_EDIT, saveCaseScorecardEdit);
}

export function* addDataSectionsList(action) {
    /* let reqobj = {
        computedReportId: action.id,
        sectionTemplateIds: action.list
    } */
    let requestUrl = `${REPORT}/computedreport/${action.id}/datasection/add`;
    try {
        const result = yield call(request, requestUrl, { data: action.list, method: 'PUT', headers: HTTP_HEADERS });
        yield put(ViewAction.addDataSectionsSuccess(result));
        // yield put({ type: ViewAction.GET_ALL_SECTIONS, data: action.id })
    } catch (err) {
        yield put(ViewAction.addDataSectionsFailure(err))
    }
}
export function* addDataSections() {
    yield takeLatest(ViewAction.ADD_DATA_SECTIONS, addDataSectionsList);
}

export function* getDataSectionsList(action) {
    let requestUrl = `${REPORT}/section/sectiontemplate/list/${action.id}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.getDataSectionsSuccess(result));
    } catch (err) {
        yield put(ViewAction.getDataSectionsFailure(err))
    }
}
export function* getDataSections() {
    yield takeLatest(ViewAction.GET_DATA_SECTIONS, getDataSectionsList);
}

export function* deleteDataSectionsList(action) {
    let requestUrl = `${REPORT}/computedreport/${action.computedreportid}/computedsection/${action.computedsectionid}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'DELETE', headers: HTTP_HEADERS });
        yield put(ViewAction.deleteDataSectionsSuccess(result));
    } catch (err) {
        yield put(ViewAction.deleteDataSectionsFailure(err))
    }
}
export function* deleteDataSections() {
    yield takeLatest(ViewAction.DELETE_DATA_SECTIONS, deleteDataSectionsList);
}

export function* getCorrespondentsList(action) {
    let requestUrl = `${CORE_API}/correspondent/assignee/${action.data}/list`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.getCorrespondentListSuccess(result.data));
    } catch (err) {
        yield put(ViewAction.getCorrespondentListFailure(err))
    }
}
export function* getCorrespondents() {
    yield takeLatest(ViewAction.GET_CORRESPONDENT_LIST, getCorrespondentsList);
}

export function* assignSurveyToCorrespondent(action) {
    let requestUrl = `${CORE_API}/task/assign/${action.id}`;
    try {
        const result = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(ViewAction.assignToCorrespondentSuccess(result));
        yield put({ type: ViewAction.GET_ALL_SECTIONS, data: action.computedReportId })
    } catch (err) {
        yield put(ViewAction.assignToCorrespondentFailure(err))
    }
}
export function* assignToCorrespondent() {
    yield takeLatest(ViewAction.ASSIGN_TO_CORRESPONDENT, assignSurveyToCorrespondent);
}

export function* approveCaseSection(action) {
    let requestUrl = `${CORE_API}/task/approve/${action.taskId}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.approveSectionSuccess(result.data));
        yield put({ type: ViewAction.GET_ALL_SECTIONS, data: action.computedreportid })
    } catch (err) {
        yield put(ViewAction.approveSectionFailure(err))
    }
}
export function* approveSection() {
    yield takeLatest(ViewAction.APPROVE_SECTION, approveCaseSection);
}

export function* rejectCaseSection(action) {
    let requestUrl = `${CORE_API}/task/reject/${action.taskId}`;
    try {
        const result = yield call(request, requestUrl, { data: action.reqbody, method: 'POST', headers: HTTP_HEADERS });
        yield put(ViewAction.rejectSectionSuccess(result.data));
        yield put({ type: ViewAction.GET_ALL_SECTIONS, data: action.computedreportid })
    } catch (err) {
        yield put(ViewAction.rejectSectionFailure(err))
    }
}
export function* rejectSection() {
    yield takeLatest(ViewAction.REJECT_SECTION, rejectCaseSection);
}
export function* downloadSubmittedTask(action) {
    let requestUrl = `${REPORT}/survey/url/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.downloadSubmittedTaskSuccess(result));
    } catch (err) {
        yield put(ViewAction.downloadSubmittedTaskFailure(err))
    }
}
export function* downloadSubmitted() {
    yield takeLatest(ViewAction.DOWNLOAD_SUBMITTED_TASK, downloadSubmittedTask);
}

export function* withdrawSingleCase(action) {
    let requestUrl = `${CORE_API}/case/withdraw`;
    try {
        const result = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(ViewAction.withdrawCaseSuccess(result));
    } catch (err) {
        yield put(ViewAction.withdrawCaseFailure(err))
    }
}
export function* withdrawCase() {
    yield takeLatest(ViewAction.WITHDRAW_CASE, withdrawSingleCase);
}

export function* getXbrlDetails(action) {
    let requestUrl = `${REPORT}/xbrl/file/counterparty/${action.data}/latest`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.fetchXbrlDetailsSuccess(result.data));
    } catch (err) {
        yield put(ViewAction.fetchXbrlDetailsFailure(err.response))
    }
}
export function* fetchXbrlDetails() {
    yield takeLatest(ViewAction.FETCH_XBRL_DETAILS, getXbrlDetails);
}

export function* downloadXbrlFile(action) {
    let requestUrl = `${REPORT}/xbrl/file/s3/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.downloadXbrlFileSuccess(result.data));
    } catch (err) {
        yield put(ViewAction.downloadXbrlFileFailure(err.response))
    }
}
export function* downloadXbrlFileDetails() {
    yield takeLatest(ViewAction.DOWNLOAD_XBRL_FILE, downloadXbrlFile);
}

export function* uploadXbrlFile(action) {
    const formData = new FormData();
    formData.append('file', action.data.file)
    let requestUrl = `${REPORT}/xbrl/file/counterparty/${action.data.id}`;
    try {
        const result = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS });
        yield put(ViewAction.uploadXbrlFileSuccess(result.data));
    } catch (err) {
        yield put(ViewAction.uploadXbrlFileFailure(err.response))
    }
}
export function* uploadXbrlFileDetails() {
    yield takeLatest(ViewAction.UPLOAD_XBRL_FILE, uploadXbrlFile);
}

export function* rerunProcessing(action) {
    let requestUrl = `${REPORT}/xbrl/file/rerun/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.rerunProcessingSuccess(result.data));
    } catch (err) {
        yield put(ViewAction.rerunProcessingFailure(err.response))
    }
}
export function* rerunXbrlProcessing() {
    yield takeLatest(ViewAction.RERUN_PROCESSING, rerunProcessing);
}

export function* epfDetails(action) {
    if (action.data && action.data !== null) {
        let requestUrl = `${CORE_API}/crawler/epfData/${action.data}`;
        try {
            const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
            yield put(ViewAction.caseDetailsEPFSuccess(listResult));
        } catch (err) {
            yield put(ViewAction.caseDetailsEPFFailure(err))
        }
    }
}
export function* fetchCaseEPFDetails() {
    yield takeLatest(ViewAction.GET_CASE_DETAILS, epfDetails);
}

export function* fetchCaseExecutiveSummaryDetails(action) {
    let requestUrl = `${REPORT}/systemdefine/executiveSummary/${action.computedReportId}/computedSection/${action.computedSectionId}/sectionaTag/${action.sectionaTag}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'POST', headers: HTTP_HEADERS });
        yield put(ViewAction.fetchcaseExecutiveSummaryDetailsSuccess(result));
    } catch (err) {
        yield put(ViewAction.fetchcaseExecutiveSummaryDetailsFailure(err))
    }
}
export function* caseExecutiveSummaryDetails() {
    yield takeLatest(ViewAction.FETCH_CASE_EXECUTIVE_SUMMARY_DETAILS, fetchCaseExecutiveSummaryDetails);
}

export function* fetchferreroKpiTemplate(action) {
    let requestUrl = `${REPORT}/systemdefine/ferreroKpi/${action.computedReportId}/computedSection/${action.computedSectionId}/sectionaTag/${action.sectionaTag}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'POST', headers: HTTP_HEADERS });
        yield put(ViewAction.fetchferreroKpiDetailsSuccess(result));
    } catch (err) {
        yield put(ViewAction.fetchferreroKpiDetailsFailure(err))
    }
}
export function* fetchferreroKpi() {
    yield takeLatest(ViewAction.FETCH_FERERO_KPI_DETAILS, fetchferreroKpiTemplate);
}

export function* getBsaEntityTypes(action) {
    let requestUrl = `${CORE_API}/crawler/bsaEntityTypes`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.bsaEntityTypesSuccess(listResult));
    } catch (err) {
        yield put(ViewAction.bsaEntityTypesFailure(err))
    }
}
export function* fetchBsaEntityTypes() {
    yield takeLatest(ViewAction.GET_BSA_ENTITY_TYPES, getBsaEntityTypes);
}

export function* getBsaBankNames(action) {
    let requestUrl = `${CORE_API}/crawler/bsaBankNames`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.bsaBankNamesSuccess(listResult));
    } catch (err) {
        yield put(ViewAction.bsaBankNamesFailure(err))
    }
}
export function* fetchBsaBankNames() {
    yield takeLatest(ViewAction.GET_BSA_BANK_NAMES, getBsaBankNames);
}

export function* getBsaAccountTypes(action) {
    let requestUrl = `${CORE_API}/crawler/bsaAccountTypes`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.bsaAccountTypesSuccess(listResult));
    } catch (err) {
        yield put(ViewAction.bsaAccountTypesFailure(err))
    }
}
export function* fetchBsaAccountTypes() {
    yield takeLatest(ViewAction.GET_BSA_ACCOUNT_TYPES, getBsaAccountTypes);
}

export function* getAllComputedSectionTemplate(action) {
    let requestUrl = `${REPORT}/computedreport/preparedComputedExcelReport/${action.data}`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.getAllComputedSectionTemplateSuccess(listResult));
    } catch (err) {
        yield put(ViewAction.getAllComputedSectionTemplateFailure(err.response))
    }
}
export function* fectchAllComputedSectionTemplate() {
    yield takeLatest(ViewAction.GET_ALL_COMPUTED_SECTION_TEMPLATE, getAllComputedSectionTemplate);
}

export function* fetchCaseScoreCardRationalDetails(action) {
    
    let requestUrl = `${REPORT}/systemdefine/scorecardRational/${action.computedReportId}/computedSection/${action.computedSectionId}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'POST', headers: HTTP_HEADERS });
        yield put(ViewAction.fetchcaseScorecardRationalDetailsSuccess(result));
    } catch (err) {
        yield put(ViewAction.fetchcaseScorecardRationalDetailsFailure(err))
    }
}
export function* caseScorecardRationalDetails() {
    yield takeLatest(ViewAction.FETCH_CASE_SCORECARD_RATIONAL_DETAILS, fetchCaseScoreCardRationalDetails);
}

export function* fetchKybData(action){
let requestUrl = `${CORE_API}/kyb/search`;
try{
    const result = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
    yield put(ViewAction.fetchKybDetailsSuccess(result));
} catch(err){
    yield put(ViewAction.fetchKybDetailsFailure(err))
}
}

export function* getKybDetails() {
    yield takeLatest(ViewAction.FETCH_KYB_DETAILS, fetchKybData);
}

export function* kybRecordSubmit(action){
    let requestUrl = `${CORE_API}/kyb/submit`;
    try{
        const result = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(ViewAction.kybRecordSubmitSuccess(result));
    } catch(err){
        yield put(ViewAction.kybRecordSubmitFailure(err))
    }
}
    
export function* kybSubmitRecord() {
    yield takeLatest(ViewAction.KYB_RECORD_SUBMIT, kybRecordSubmit);
}

export function* markCaseAsPending(action) {
    let requestUrl = `${CORE_API}/case/mark/pending/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.markCasePendingSuccess(result));
    } catch (err) {
        yield put(ViewAction.markCasePendingFailure(err.response))
    }
}
export function* markCasePending() {
    yield takeLatest(ViewAction.MARK_CASE_PENDING, markCaseAsPending);
}

export function* fetchScoreBreakUpDetails(action) {
    let requestUrl = `${REPORT}/score/breakup/generate/${action.computedReportId}/tag/${action.sectiontag}`;
    try {
        const result = yield call(request, requestUrl, {method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.fetchScoreBreakUpDetailsSuccess(result));
    } catch (err) {
        yield put(ViewAction.fetchScoreBreakUpDetailsFailure(err))
    }
}
export function* scoreBreakUpDetails() {
    yield takeLatest(ViewAction.FETCH_SCORE_BREAK_UP_DETAILS, fetchScoreBreakUpDetails);
}

export function* fetchScoreSummaryDetails(action) {
    let requestUrl = `${REPORT}/score/breakup/summary/${action.computedReportId}/computedSection/${action.computedSectionId}`;
    try {
        const result = yield call(request, requestUrl, {method: 'GET', headers: HTTP_HEADERS });
        yield put(ViewAction.fetchScoreSummaryDetailsSuccess(result));
    } catch (err) {
        yield put(ViewAction.fetchScoreSummaryDetailsFailure(err))
    }
}
export function* scoreSummaryDetails() {
    yield takeLatest(ViewAction.FETCH_SCORE_SUMMARY_DETAILS, fetchScoreSummaryDetails);
}

function* downloadCaseAttachment(action) {
    let requestUrl = `${REPORT}/case/downloadAttachments/${action.fileName}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        var blob = new Blob([result.data],
            { type: 'application/zip' });
        fileSaver.saveAs(blob, action.fileName);
        yield put(ViewAction.downloadAttachmentSuccess(result));
    } catch (err) {
        yield put(ViewAction.downloadAttachmentFailure(err))
    }
}

export function* downloadAttachments() {
    yield takeLatest(ViewAction.DOWNLOAD_ATTACHMENT_REQUEST, downloadCaseAttachment);
}
